import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { useGetColumns } from '../hooks/useGetColumns';
import { useGetFilters } from '../hooks/useGetFilters';
import { useGetRows } from '../hooks/useGetRows';
import { useMemo, useState, useEffect } from 'react';
import './reporteBOTContent.scss';
import { ReporteBOTFilters } from './ReporteBOTFilters';
import { downloadExcel } from '../../../utils/downloadExcel';
import { gridConfigs } from '../constants/gridConfigs';
import { CustomButton } from '../../../components/customButton/CustomButton';

export const ReporteBOTContent = ({ setChildrenAction }) => {
    const [isRefetchRequired, setIsRefetchRequired] = useState(true);

    const {
        filters,
        handleChangeFilters,
        delegaciones,
        tiposReporte
    } = useGetFilters();

    const [tipoRemitoId, tipoAutorizacionId] = useMemo(() => {
        const tipoRemito = tiposReporte.find(tr => tr.name === 'Remitos');
        const tipoAutorizacion = tiposReporte.find(tr => tr.name === 'Autorizaciones');
        return [tipoRemito?.id, tipoAutorizacion?.id];
    }, [tiposReporte]);

    const {
        rows,
        setRows,
        loading,
        totalCount,
        handleSearch
    } = useGetRows(filters, tipoRemitoId, tipoAutorizacionId, setIsRefetchRequired);

    const columns = useGetColumns({ filters, tipoRemitoId, tipoAutorizacionId });

    const handleFilters = (name, value) => {
        setRows([]);
        setIsRefetchRequired(true);
        handleChangeFilters(name, value);
    }

    const exportExcel = () => {
        // Determinar las columnas según el tipoReporte
        let selectedColumns;
        if (filters.tipoReporte === tipoRemitoId) {
            selectedColumns = gridConfigs.REMITO.columns;
        } else if (filters.tipoReporte === tipoAutorizacionId) {
            selectedColumns = gridConfigs.AUTORIZACION.columns;
        } else {
            selectedColumns = gridConfigs.DEFAULT.columns;
        }

        // Obtener el nombre del tipoReporte para el nombre del archivo
        const tipoReporteName = tiposReporte.find(tr => tr.id === filters.tipoReporte)?.name || 'reporte';

        downloadExcel({
            fileName: `Reporte_${tipoReporteName}`,
            sheet: "Reporte",
            tablePayload: {
                header: selectedColumns,
                body: rows
            }
        });
    }
    const exportLoading = false;

    useEffect(() => {
        setChildrenAction(() =>
            <CustomButton
                label='Exportar'
                loading={exportLoading}
                onClick={exportExcel}
                variant='contained'
                disabled={!rows.length}
            >
                Exportar
            </CustomButton>
        );
    }, [setChildrenAction, rows, exportLoading]);

    return (
        <div>
            <ReporteBOTFilters
                delegaciones={delegaciones}
                tiposReporte={tiposReporte}
                filters={filters}
                handleChangeFilters={handleFilters}
                handleSearch={handleSearch}
            />

            <DataGridGenerico
                columns={columns}
                rows={rows}
                totalCount={totalCount}
                loading={loading}
                toolbar={false}
                localeText={{
                    noRowsLabel: isRefetchRequired ?
                        'Haz click en "Buscar" para aplicar los nuevos filtros' :
                        "Sin filas"
                }}

            />
        </div>
    );
}